import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initializeGTM } from './utils/gtm';
import './index.css';
import './i18n';

// Initialize GTM with hardcoded container ID (same for all environments)
const GTM_CONTAINER_ID = 'GTM-N8ZWW89P';

initializeGTM({ gtmId: GTM_CONTAINER_ID });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
